import React from 'react';
import { css } from 'styled-components';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import MediaBorders from 'constants/media-borders';
import OrderAggregatorsHeader from '../components/Header';
import i18n from 'i18n';
import Button from 'components/common/Button';
import SessionManager from 'util/session-manager';
import BlockHeader from 'components/common/BlockHeader';
import { zeroPadStart } from 'util/filters';

class Completion extends React.Component {
  constructor() {
    super();

    this.state = {
      loaded: false
    };
  }

  componentDidMount() {
    this.data = this.restoreData();
    SessionManager.clear();
    this.setState({
      loaded: true
    });
  }

  restoreData = () => {
    let savedData;
    try {
      savedData = SessionManager.loadCompletionData();
    } catch (error) {
      switch (error.name) {
        case 'NoSessionError':
        case 'SessionExpiredError':
        case 'LoadDataError':
          this.props.push('/error');
          return;

        default:
          throw error;
      }
    }

    return savedData;
  };

  render() {
    const {
      className,
      match: { path },
      push
    } = this.props;

    if (!this.state.loaded) {
      return null;
    }

    return (
      <div className={className}>
        <OrderAggregatorsHeader path={path} />
        <div className="order-aggregators-container">
          <div className="order-aggregators-content">
            <BlockHeader>
              {i18n.t('orderAggregators:completion:gratitudeMessage')}
            </BlockHeader>

            <ul className="order-completion-info">
              <li>
                <div className="label">
                  {i18n.t('orderAggregators:completion:orderNumber')}
                </div>
                <div className="value">{zeroPadStart(this.data.userId)}</div>
              </li>
              <li>
                <div className="label">
                  {i18n.t('orderAggregators:completion:password')}
                </div>
                <div className="value">{this.data.password}</div>
              </li>
            </ul>
            <ul className="notification">
              <li>
                {i18n.t(
                  'orderAggregators:completion:howToConfirmOrderContentMessage'
                )}
              </li>
              <li>
                {i18n.t('orderAggregators:completion:completionMailSendNotice')}
              </li>
              <li>
                {i18n.t('orderAggregators:completion:completionMailNote1')}
              </li>
              <li>
                {i18n.t('orderAggregators:completion:completionMailNote2')}
              </li>
            </ul>
            <Button
              type="button"
              buttonType="B"
              onClick={() =>
                window.open(
                  this.props.history.createHref({ pathname: '/mypage/login' })
                )
              }
            >
              {i18n.t('orderAggregators:completion:OrderContentConfirmation')}
            </Button>
            <Button type="button" buttonType="F" onClick={() => push('/')}>
              {i18n.t('orderAggregators:completion:backToTop')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const commonStyle = css`
  ${BlockHeader} {
    &:after {
      left: 50%;
      transform: translate(-50%, 0);
    }
  }

  .order-aggregators-content {
    max-width: ${MediaBorders.large};
    text-align: center;
    margin: 0 auto;

    ul {
      padding-left: 0;
      margin: 0 auto;

      li {
        list-style: none;
      }
    }

    .order-completion-info {
      display: table;

      li {
        display: table-row;
        ${FontStyles.text5};

        .label {
          display: table-cell;
          text-align: right;
          color: ${Colors.black1};
        }

        .value {
          display: table-cell;
          text-align: left;
          color: ${Colors.orange1};
        }
      }
    }

    .notification {
      ${FontStyles.text8};

      color: ${Colors.black1};
      text-align: center;
    }

    button {
      display: block;
      margin: 0 auto;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .order-aggregators-container {
    padding: 0 80px 160px;
    margin: 0 auto;

    .order-aggregators-content {
      .order-completion-info {
        margin-bottom: 32px;
      }

      .notification {
        margin-bottom: 40px;

        li:first-child {
          margin-bottom: 32px;
        }
      }

      button {
        margin-bottom: 40px;
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .order-aggregators-container {
    padding: 0 16px 32px;

    .order-aggregators-content {
      .order-completion-info {
        margin-bottom: 24px;
      }

      .notification {
        width: 256px;
        margin-bottom: 32px;

        li:first-child {
          width: 210px;
          margin: 0 auto 24px;
        }
      }

      button {
        margin-bottom: 32px;
      }
    }
  }
`;

export default applyStyles(Completion)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Completion/index.js